import { ButtonGroup, Button } from '@leroy-merlin-br/backyard-react-ui'

const FilterButtons = ({
  currentType,
  filterByActivated,
  filterByAvailable
}) => {
  const isDefault = currentType === 'activated'

  return (
    <ButtonGroup label="filter" align="flex-start" inlineMobile>
      <Button
        size="kilo"
        variant={!isDefault && 'outline'}
        color={isDefault ? 'purple' : 'gray'}
        onClick={filterByActivated}
      >
        Ativados
      </Button>
      <Button
        size="kilo"
        variant={isDefault && 'outline'}
        color={isDefault ? 'gray' : 'purple'}
        onClick={filterByAvailable}
      >
        Disponíveis
      </Button>
    </ButtonGroup>
  )
}

export default FilterButtons
